/*-----------------------------------------------------------------
- Button translations
-----------------------------------------------------------------*/
export default {
    
    add_question: 'Add Question',
    
};
